<template>
  <div class="avatar" :class="[size, variant, { disabled, online }]">
    <div v-if="avatar?.url && !avatar?.canNotLoad && !isLoadAvatarError" class="img">
      <v-img :src="avatar.url" width="100%" height="100%" cover @error="onError" />
    </div>

    <template v-else>
      {{ literal }}
    </template>

    <div v-if="showError && (avatar?.canNotLoad || isLoadAvatarError)" class="avatar__alert">
      !
      <e-tooltip :max-width="327">
        <div class="text-secondary paragraph-s"><b>Не удалось загрузить изображение</b></div>
        <div class="text-secondary paragraph-xs mt-2">
          не пытайтесь загрузить новое изображение, всё получится после того как мы решим проблему с сервером
        </div>
      </e-tooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ETooltip } from '@/core/components/ui';

defineProps<{
  literal: string;
  size: 'S' | 'M' | 'L' | 'XL' | 'XXL';
  disabled?: boolean;
  online?: boolean;
  avatar?: {
    url?: string | null | undefined;
    canNotLoad: boolean;
  } | null;
  showError?: boolean;
  variant?: 'primary';
}>();

const isLoadAvatarError = ref(false);

const onError = () => {
  isLoadAvatarError.value = true;
};
</script>

<style scoped lang="scss">
.avatar {
  position: relative;

  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  color: $text-white-color;
  text-transform: uppercase;

  background-color: $status-green;
  border-radius: 50%;

  &.disabled {
    background-color: $bg-color-medium;
  }

  &.online {
    &:after {
      content: '';
      position: absolute;
      right: -1px;
      bottom: -1px;

      width: 10px;
      height: 10px;

      background: $status-green;
      border: 1px solid $main-bg-color;
      border-radius: 50%;
    }
  }

  .img {
    width: 100%;
    height: 100%;
    overflow: hidden;

    border-radius: 50%;
  }

  &.S {
    width: 32px;
    height: 32px;

    font-size: $paragraph-xs-font-size;
  }

  &.M {
    width: 48px;
    height: 48px;

    font-size: $paragraph-m-font-size;
  }

  &.L {
    width: 64px;
    height: 64px;

    font-size: $h3-font-size;
  }

  &.XL {
    width: 120px;
    height: 120px;

    font-size: $h1-font-size;
  }

  &.XXL {
    width: 200px;
    height: 200px;

    font-size: 60px;
  }

  &.primary {
    background-color: $primary-color;
  }

  &__alert {
    position: absolute;
    top: 20px;
    right: 20px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 20px;

    font-size: 12px;
    color: $text-white-color;

    background-color: $alert-color;
    border: 1.5px solid $white-color;
    border-radius: 50%;
  }
}
</style>
